import { render } from "./admission.vue?vue&type=template&id=1483bb9f&scoped=true"
import script from "./admission.vue?vue&type=script&lang=js"
export * from "./admission.vue?vue&type=script&lang=js"

import "./admission.vue?vue&type=style&index=0&id=1483bb9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1483bb9f"]])

export default __exports__